export default __webpack_public_path__ + "static/media/hht2_ani_13.bda1b2c9.png";